/**
 * Shared Recharts styling for the inspector panel.
 *
 * Built on the platform's tokens and the same RTL conventions the reports
 * module uses (`@/features/reports/lib/chartTheme`): the value axis sits on the
 * right and the category axis runs right-to-left. The chart surface itself is
 * pinned to LTR by `.tr-panel .recharts-wrapper` in traceability.css; tooltips
 * re-assert RTL so their content reads correctly.
 */

import { createElement } from 'react';
import {
    chartGridStroke,
    chartTooltipStyle,
    rtlXAxisProps,
    rtlYAxisProps,
} from '@/features/reports/lib/chartTheme';
import { Legend } from 'recharts';

export const chartLegendStyle = {
    fontFamily: 'var(--font)',
    fontSize: 16,
    fontWeight: 600,
    color: 'var(--text-primary)',
};

export function ChartLegend(props) {
    const { wrapperStyle, ...legendProps } = props;
    return createElement(Legend, {
        iconSize: 20,
        wrapperStyle: {
            ...chartLegendStyle,
            ...wrapperStyle,
        },
        ...legendProps,
    });
}

export const COLORS = {
    primary: 'var(--green)',
    amber: '#F59E0B',
    muted: 'var(--gray-dark)',
    grid: chartGridStroke,
};

export { chartTooltipStyle, rtlXAxisProps, rtlYAxisProps };
